// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs a{cursor:pointer}.breadcrumbs a.disabled{color:grey;cursor:default}", ""]);
// Exports
module.exports = exports;
